module.exports = __webpack_public_path__ + "img/idcardPic.69fd1e44.png";